import React from 'react';
import { Navigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { userSelect } from '../redux/selectors/index';

// handle the private routes
function PrivateRoute({ children }) {
  const users = useSelector(userSelect);
  
  const isAuthenticated = ((users?.emailVerification ?? 0) == 1) && ((users?.phoneVerification ?? 0) == 1);
  
  return isAuthenticated ? children : <Navigate to="/user-verification" replace />;
}

export default PrivateRoute;